var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ darken: _vm.darken },attrs:{"id":"app-title"}},[_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.info))])])}
var staticRenderFns = []

export { render, staticRenderFns }